/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import React from 'react';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import { cacularPaddingLeft } from './_util/cacularPaddingLeft.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-8c8a3203.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';

var MenuGroup = function MenuGroup(_ref) {
  var title = _ref.title,
    children = _ref.children,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 1 : _ref$level;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var itemAndGroupPaddingBias = 28;
  var menuPaddingLeft = cacularPaddingLeft(level - 1) - itemAndGroupPaddingBias;
  return /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(classPrefix, "-menu-group"))
  }, /* @__PURE__ */React.createElement("div", {
    className: classNames("".concat(classPrefix, "-menu-group__title")),
    style: {
      paddingLeft: "".concat(menuPaddingLeft, "px")
    }
  }, title), children);
};
MenuGroup.displayName = "MenuGroup";

export { MenuGroup as default };
//# sourceMappingURL=MenuGroup.js.map
